export default __webpack_public_path__ + "static/media/2023-03-02T06_03_25.953Z_2_10.41dd4889.jpeg";